import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_META_DATA } from '@seech-sub/core-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import {
  FeedbackAssignRequest,
  FeedbackCommentDetail,
  FeedbackCommentRequest,
  FeedbackDetail,
  FeedbackQuery,
  FeedbackStatusRequest,
  FeedbackUpdateRequest,
  PagedResult,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class FeedbackClientService {
  private readonly quietContext = new HttpContext().set(REQUEST_META_DATA.HIDE_PROGRESS, true);
  private readonly http = inject(HttpClient);

  queryFeedback(query: FeedbackQuery): Observable<PagedResult<FeedbackDetail>> {
    return this.http.post<PagedResult<FeedbackDetail>>(OperationsApiRoutes.feedbackQuery, query, {
      context: this.quietContext,
    });
  }

  getFeedback(id: string): Observable<FeedbackDetail> {
    return this.http.get<FeedbackDetail>(OperationsApiRoutes.feedbackById(id), {
      context: this.quietContext,
    });
  }

  updateFeedback(id: string, request: FeedbackUpdateRequest): Observable<FeedbackDetail> {
    return this.http.put<FeedbackDetail>(OperationsApiRoutes.feedbackById(id), request);
  }

  setStatus(id: string, request: FeedbackStatusRequest): Observable<FeedbackDetail> {
    return this.http.post<FeedbackDetail>(OperationsApiRoutes.feedbackStatus(id), request);
  }

  assign(id: string, request: FeedbackAssignRequest): Observable<FeedbackDetail> {
    return this.http.post<FeedbackDetail>(OperationsApiRoutes.feedbackAssign(id), request);
  }

  addComment(id: string, request: FeedbackCommentRequest): Observable<FeedbackCommentDetail> {
    return this.http.post<FeedbackCommentDetail>(OperationsApiRoutes.feedbackComments(id), request);
  }

  publish(id: string): Observable<FeedbackDetail> {
    return this.http.post<FeedbackDetail>(OperationsApiRoutes.feedbackPublish(id), {});
  }

  unpublish(id: string): Observable<FeedbackDetail> {
    return this.http.post<FeedbackDetail>(OperationsApiRoutes.feedbackUnpublish(id), {});
  }
}
